// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r4Ug","buttons":"styles_buttons__1UNCn"};